import React, {useState} from 'react';
import axios from "axios";
import {resendEmail} from "../../network/apis/auth.api";
import {useSystemAlertContext} from "../../context/SystemAlertContext";
import {useOrganization} from "../../context/OrganizationContext";
import * as turf from '@turf/turf';

const DetailBarButtons = ({
                              view,
                              setView,
                              detailbarVisible,
                              setDetailbarVisible,
                              detailbarContent,
                              authenticated,
                              preCheck,
                              preInvalidCheck,
                              maxAltitude,
                              altitude,
                              selectedPurpose,
                              profile,
                              selectedTimeZone,
                              setSelectedTimeZone,
                              selectedDate,
                              selectedTime,
                              isCurrentDateInPast,
                              getISOTimeInTimeZone,
                              captchaValue,
                              loadOperations,
                              circleGeoJSON,
                              circleCenter,
                              HomeStyles,
                              isUserEmailVerified,
                              alert,
                              handleCloseAlert,
                              onReview,
                              detailbarButtonVisible
                          }) => {

    const [verifyLinkText, setVerifyLinkText] = useState("Verify Now");
    const { hasAlerts } = useSystemAlertContext();
    const { subscriptionStatus } = useOrganization();

    const verifyEmail = async (email) => {
        try {
            // const response = await axios.get(`/api/auth/email_verification_status/${email}`);
            setVerifyLinkText("Sending Email...");
            const response = await resendEmail(profile.email, profile.userId);
            if (response.status === 200) {
                setVerifyLinkText("Email Sent");
            } else {
                setVerifyLinkText("Error Sending Email");
            }
        } catch (error) {
            alert("An error occurred while verifying your email.");
            //TODO: log application error with email
        }
    };

    /**
     * Sanitizes polygon geometry before submission
     * - Rounds coordinates to 8 decimal places
     * - Removes duplicate vertices
     * - Ensures clockwise winding order
     * - Returns sanitized geometry
     */
    const sanitizePolygonGeometry = (geometry) => {
        if (!geometry || geometry.type !== 'Polygon') {
            return geometry; // Not a polygon, return as-is
        }

        const COORDINATE_PRECISION = 5; // 5 decimal places = ~1.1 meter precision
        const TOLERANCE = 0.00001; // ~1 meter (consistent with drawing tolerance)


        try {
            const coordinates = geometry.coordinates[0]; // Exterior ring

            // Step 1: Normalize coordinates (round to precision)
            const normalizedPoints = coordinates.map(point => [
                Number(point[0].toFixed(COORDINATE_PRECISION)),
                Number(point[1].toFixed(COORDINATE_PRECISION))
            ]);

            // Step 2: Remove duplicates (exclude closing point for deduplication)
            const openPoints = normalizedPoints.slice(0, -1);
            const cleanedPoints = [];

            for (let i = 0; i < openPoints.length; i++) {
                const current = openPoints[i];
                const isDuplicate = cleanedPoints.some(existing => {
                    const distance = Math.sqrt(
                        Math.pow(existing[0] - current[0], 2) +
                        Math.pow(existing[1] - current[1], 2)
                    );
                    return distance < TOLERANCE;
                });

                if (!isDuplicate) {
                    cleanedPoints.push(current);
                } else {
                }
            }

            // Step 3: Close the polygon
            const closedPoints = [...cleanedPoints, cleanedPoints[0]];

            // Step 4: Ensure clockwise winding order
            const testPolygon = turf.polygon([closedPoints]);
            const isClockwise = turf.booleanClockwise(closedPoints);

            let finalPoints = closedPoints;
            if (!isClockwise) {
                const reversedOpen = [...cleanedPoints].reverse();
                finalPoints = [...reversedOpen, reversedOpen[0]];
            }

            return {
                type: 'Polygon',
                coordinates: [finalPoints]
            };

        } catch (error) {
            return geometry; // Return original on error
        }
    };


    return (
        <>
            {(detailbarVisible && !authenticated ||
                    !detailbarContent.layers.proceed_next ||
                    (authenticated && !preCheck) ||
                    (authenticated && !preInvalidCheck) ||
                    // (authenticated && (subscriptionStatus !== "active" && subscriptionStatus !== "trialing" && subscriptionStatus !== "past_due")) ||
                    (maxAltitude === 0 || altitude === 0) ||
                    ((setSelectedTimeZone !== '' && selectedDate !== '' && selectedTime !== '' && isCurrentDateInPast(getISOTimeInTimeZone(selectedTimeZone), selectedDate + " " + selectedTime))) ||
                    (authenticated && !isUserEmailVerified) ||
                    (detailbarContent.layers.proceed_next && detailbarContent.layers.authorizations_array.authorizations.length === 0 && (maxAltitude > 0 || altitude > 0) && authenticated && preCheck) ||
                    ((authenticated && profile) && ((profile?.faaIDType === "Part 107" && (typeof selectedPurpose === 'undefined' || selectedPurpose === "44809")))) ||
                    (authenticated && profile) && ((profile?.faaIDType === "44809" && (selectedPurpose === 'Part 107'))) ||
                    hasAlerts) &&
                <div className={HomeStyles.user_detail_notification}>
                    {!authenticated && <p> Please log in to proceed with flight authorizations </p>}
                    {(authenticated && !preCheck) &&
                        <p> There is one or more operation for this operator and time period. The operator should
                            cancel all operations that will not be used before the operation start time</p>}
                    {(authenticated && !preInvalidCheck) &&

                        <p> There are invalid/rescinded operation(s) pending user acknowledgment </p>}

                    {(authenticated && profile) && ((profile?.faaIDType === "Part 107" && (typeof selectedPurpose === 'undefined' || selectedPurpose === "§ 44809"))) &&
                        <p>Your account is registered for {profile?.faaIDType} drone operations. Please select the
                            correct operation mode</p>
                    }

                    {(authenticated && profile) && ((profile?.faaIDType === "44809" && (selectedPurpose === 'Part 107'))) &&
                        <p>Your account is registered for {profile.faaIDType} drone operations. Please select the
                            correct operation mode</p>
                    }

                    {authenticated && !(profile?.faaIDType === "44809" || profile?.faaIDType === "Part 107") &&
                        <p>Please select the operation mode for the account&nbsp;
                            <a
                                href="/profile"
                                style={{color: '#007bff', textDecoration: 'underline', cursor: 'pointer'}}
                            >
                                Profile Settings
                            </a>
                        </p>
                    }

                    {authenticated && (
                            !(profile?.faaIDValue?.trim() !== "") ||
                            !(
                                profile?.phoneNumber &&
                                profile.phoneNumber.replace(/\D/g, "").length >= 2 &&
                                profile.phoneNumber.replace(/\D/g, "").length <= 15
                            )
                        ) &&
                        <p>Please complete the user profile&nbsp;
                            <a
                                href="/profile"
                                style={{color: '#007bff', textDecoration: 'underline', cursor: 'pointer'}}
                            >
                                Profile Settings
                            </a>
                        </p>
                    }

                    {/* {(authenticated && (subscriptionStatus !== "active" && subscriptionStatus !== "trialing" && subscriptionStatus !== "past_due")) &&
                        <p>Please finalize the account subscription setup&nbsp;
                            <a
                                href="/profile?tab=billing"
                                style={{color: '#007bff', textDecoration: 'underline', cursor: 'pointer'}}
                            >
                                here
                            </a>
                        </p>
                    } */}

                    {!detailbarContent.layers.proceed_next && <p> Check Above Advisories</p>}
                    {detailbarContent.layers.proceed_next && (maxAltitude === 0 || altitude === 0) &&
                        <p>Check altitude selection </p>}
                    {detailbarContent.layers.proceed_next && detailbarContent.layers.authorizations_array.authorizations.length === 0 && (maxAltitude > 0 || altitude > 0) && authenticated && preCheck &&
                        <p> No LAANC authorization requests were detected in the operation. The operation can still
                            be submitted and managed through Flyzone</p>}

                    {setSelectedTimeZone !== '' && selectedDate !== '' && selectedTime !== '' && isCurrentDateInPast(getISOTimeInTimeZone(selectedTimeZone), selectedDate + " " + selectedTime) &&
                        <p> The selected date/time is in the past</p>}

                    {authenticated && !isUserEmailVerified &&
                        <p>
                            Please verify your email address to proceed with flight authorizations.&nbsp;
                            {verifyLinkText === "Verify Now" && <a
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    verifyEmail(profile.email);
                                }}
                                style={{color: '#007bff', textDecoration: 'underline', cursor: 'pointer'}}
                            >
                                {verifyLinkText}
                            </a>}
                            {verifyLinkText !== "Verify Now" &&
                                <span style={{color: '#28a745'}}>{verifyLinkText}</span>}
                        </p>
                    }

                    {hasAlerts &&
                        <p>Please review the active system alert before proceeding</p>
                    }

                </div>}
            {detailbarButtonVisible && <div className={HomeStyles.close_next}>
    <span
        id="closedetailbar"
        className={HomeStyles.closedetailbar}
        onClick={() => {
            if (view === 'personalInfo') {
                setView('detailbar');
            } else {
                setDetailbarVisible(false);
            }
        }}
    >
      {view === 'personalInfo' ? 'Back' : 'Close'}
    </span>
                {detailbarVisible && (
                    <span
                        id="next"
                        className={`${HomeStyles.next_button} ${(!detailbarContent.layers.proceed_next ||
                            !authenticated ||
                            (authenticated && !preCheck) ||
                            (authenticated && !preInvalidCheck) ||
                            (maxAltitude === 0 || altitude === 0) ||
                            // (authenticated && (subscriptionStatus !== "active" && subscriptionStatus !== "trialing" && subscriptionStatus !== "past_due")) ||
                            (authenticated && !isUserEmailVerified) ||
                            ((authenticated && profile) && ((profile?.faaIDType === "Part 107" && (typeof selectedPurpose === 'undefined' || selectedPurpose === "§ 44809")))) ||
                            ((authenticated && profile) && ((profile?.faaIDType === "44809" && (selectedPurpose === 'Part 107')))) ||
                            ((authenticated && profile) && !(profile?.phoneNumber &&
                                profile.phoneNumber.replace(/\D/g, "").length >= 2 &&
                                profile.phoneNumber.replace(/\D/g, "").length <= 15)) ||
                            (setSelectedTimeZone !== '' && selectedDate !== '' && selectedTime !== '' && isCurrentDateInPast(getISOTimeInTimeZone(selectedTimeZone), selectedDate + " " + selectedTime)) &&
                            !captchaValue ||
                            hasAlerts) ? HomeStyles.disabled : ''}`}
                        onClick={() => {
                            if (view === 'detailbar') {
                                setView('personalInfo');
                            } else {
                                const operationData = {
                                    selected_date_time: detailbarContent.layers.timestamps.startDateTime,
                                    op_end_datetime: detailbarContent.layers.timestamps.endDateTime,
                                    selected_timezone: selectedTimeZone,
                                    duration: detailbarContent.layers.timestamps.duration,
                                    operator_name: profile.firstName + " " + profile.lastName,
                                    operator_faa_id: profile.faaIDValue,
                                    operator_email: profile.email,
                                    operator_phone: profile.phoneNumber,
                                    operation_type: (selectedPurpose === "" || selectedPurpose === "§ 44809") ? "44809" : "part_107",
                                    boundary_polygon_geojson: JSON.stringify(
                                        circleGeoJSON.geometry.type === 'Polygon'
                                            ? sanitizePolygonGeometry(circleGeoJSON.geometry)
                                            : circleGeoJSON.geometry
                                    ),
                                    // Origin point: Where user clicked for circle or first point for polygon
                                    point_location_geojson: JSON.stringify({
                                        coordinates: circleCenter,
                                        type: "Point",
                                    }),
                                    operation_metadata: JSON.stringify(detailbarContent),
                                };

                                // Log the point_location_geojson being sent
                                console.log('[DetailBarButtons] Sending point_location_geojson:', {
                                    circleCenter,
                                    point_location_geojson: JSON.stringify({
                                        coordinates: circleCenter,
                                        type: "Point",
                                    })
                                });

                                // Log the origin point for verification
                                console.log('Operation Origin Point:', {
                                    geometryType: circleGeoJSON.geometry.type,
                                    originCoordinates: circleCenter,
                                    isCircle: circleGeoJSON.geometry.type !== 'Polygon' || circleGeoJSON.properties?.isCircle,
                                    firstPolygonPoint: circleGeoJSON.geometry.type === 'Polygon' && !circleGeoJSON.properties?.isCircle
                                        ? circleGeoJSON.geometry.coordinates[0][0]
                                        : null
                                });

                                loadOperations(operationData);
                            }
                        }}
                    >
        {view === 'detailbar' ? 'Next' : 'Finish'}
      </span>
                )}
            </div>}
            {alert.visible && (
                <div className={HomeStyles.alert}>
                    <span>{alert.content}</span>
                    <div style={{ display: 'flex', gap: '8px', marginTop: '8px', flexWrap: 'wrap' }}>
                        {alert.operationId && onReview && (
                            <button onClick={onReview} style={{ background: '#0B62A1', color: '#fff', border: 'none', borderRadius: '4px', padding: '6px 12px', cursor: 'pointer', fontWeight: 600 }}>
                                Review in Mission Log
                            </button>
                        )}
                        <button onClick={handleCloseAlert}>Close</button>
                    </div>
                </div>)}
        </>
    );
};
export default DetailBarButtons;